/* Footer navigation stays expanded on all screen sizes. */
(() => {
  const init = (scope) => scope.querySelectorAll('footer.im-footer').forEach(footer => {
    footer.querySelectorAll('.im-footer__menu-toggle').forEach(button => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      button.closest('.footer-block--menu')?.classList.add('im-footer__menu-ready');
      button.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    });
  });
  init(document);
  if (!window.imFooterSectionListener) {
    window.imFooterSectionListener = true;
    document.addEventListener('shopify:section:load', event => init(event.target));
  }
})();
